import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import ProjectCard from "../components/projects/ProjectCard";
import Tabs from "../components/projects/Tabs/Tabs";
import { Container } from "../styles/global";

const ProjectList = [
  {
    catetogry: "AI And ML",
    name: "Pup Teller",
    image: "/assest/images/projectsimages/pupteller.png",
    tech: "Pytorch, Python, Flask, Django, React, TypeScript",
    description: [
      "Developed a dog breed detection ML model using PyTorch with ResNet-50 architecture, trained on 5000+ images across 30 dog breeds and achieved 97% model accuracy utilizing a transfer learning approach.",
      "Programmed REST APIs using Django to facilitate communication between the ML model and the web application.",
      "Built React web app for user-friendly interaction with ML model for enabling easy access to dog breed insights.",
    ],
    link: "https://pupteller.netlify.app/",
  },
  {
    catetogry: "AI And ML",
    name: "NewsCheckmate",
    image: "/assest/images/projectsimages/fakenews.png",
    tech: "Python,  Scikit-learn, NLP, Matplotlib, Flask, React, TypeScript",
    description: [
      "Developed an ML model using NLP techniques trained with a large volume of News data, achieving an accuracy of 98%.",
      "Created a REST API using Flask to bridge communication channels between the ML model and the web application.",
      "Programmed a user-friendly client-facing portal using React and Typescript to provide a platform for news validation.",
    ],
    link: "https://news-checkmate.netlify.app/",
  },
  {
    catetogry: "Web And Mobile",
    name: "Stay Mates ( Hotel booking  app )",
    image: "/assest/images/projectsimages/staymates.png",
    tech: "Next JS, TypeScript,React,Redux-ToolKit, Mongo DB",
    description: [
      "Developed 'Staymates,' a hotel booking application using Next.js, React, and TypeScript.",
      "Implemented Next Auth for secure and user-friendly authentication.",
      "Designed a user-friendly interface with Tailwind CSS, Material UI, and Styled Components for an appealing user experience.",
      "Utilized Redux Toolkit for efficient state management, enhancing app performance.",
      "Employed a monolithic architecture for code-base and seamlessly deployed it on Vercel for efficient hosting.",
    ],
    link: "https://staymates.vercel.app/",
  },
  {
    catetogry: "Web And Mobile",
    name: "Moments ( Social media web app )  ",
    image: "/assest/images/projectsimages/moments.png",
    tech: "JavaScript, React Js, Redux, Redux-Thunk ,Node Js, Express Js, Mongo DB",
    description: [
      "MERN STACK web application. ",
      "Developed client side code base as well as server side.",
      "Posts recommendation  implementation.",
      "Implemented comments section.",
      "Used Axios for API Integration. And developed API using express js.",
      "JWT authentication is been implemented.",
    ],

    link: "https://github.com/PruthviPatel2001/moments_mern_stack",
  },
  {
    catetogry: "Web And Mobile",
    name: "supermart gaming shop ( e-comm web app )",
    image: "/assest/images/projectsimages/supermart.png",
    tech: "JavaScript, React Js",
    description: [
      "Build e-comm web-app using  react.js.",
      "Used commerceJs for backend and API service. ",
      "Used StripeJs and react-stripe-js for the payment process.",
      "Used React-hook-form package to build form component.",
    ],
    link: "https://supermartgamingshop.netlify.app/",
  },
  {
    catetogry: "Web And Mobile",
    name: "GoCrypto",
    image: "/assest/images/projectsimages/gocrypto.png",
    tech: "React native, Redux, Redux-Thunk",
    description: [
      "React Native mobile app build on Expo CLI. ",
      "Used Redux for state management and Redux-Thunk as middleware.",
      "Utilize Coingecko API for fetching live prices for top cryptocurrencies.",
      "Used animated chart for representing price flactuation of crypto coin.",
    ],
    link: "https://expo.dev/@pruthvi_patel/GoCrypto",
  },
  {
    catetogry: "Web And Mobile",
    name: "Food's Up",
    image: "/assest/images/projectsimages/foodsup.png",
    tech: "React native, Redux-Toolkit, Tailwind,Sanity Io",
    description: [
      "React Native mobile app build on Expo CLI. ",
      "Used Redux Toolkit for state management.",
      "Developed backend on Sanity Io platform and utilize it in the application. ",
      "Worked with react native map for location purposes.",
      "Configure Tailwind CSS to do better with UI.",
    ],
    link: "https://expo.dev/@pruthvi_patel/FoodsUp",
  },
  {
    catetogry: "AI And ML",
    name: "House Price Prediction",
    image: "/assest/images/projectsimages/houseprice.png",

    tech: "Python, Scikit Learn, Numpy, Pandas, Matplotlib",
    description: [
      "Develop an ML model for house price prediction.",
      "Performed Data visualization for getting insights from the set of data. ",
      "Correlations check with the provided label to check the relation of features with it.",
      "Try some attribute combinations to develop more features. ",
      "Tried out different regressor models to find the best fit model. ",
      "Perform model evaluation to find out the best model for present data.",
      "Create a pipeline using SKLearn for execution workflow. ",
    ],

    link: "https://colab.research.google.com/drive/1qCIQ3i-SkpIanZXbmYoLBmk7Jxy-tEXi?usp=sharing",
  },
  {
    catetogry: "AI And ML",
    name: "Movie Recommendation System",
    image: "/assest/images/projectsimages/movie.png",
    tech: "Python, Scikit Learn, Numpy, Pandas, Matplotlib",
    description: [
      "Develop a recommandation model which recommended a movie similar to the movie user asked for.",
      "Perform Data pre-processing to clean the data.",
      "Select the relevant feature from the data set to train the model.",
      "TfidfVectorizer to convert text data to feature vector.",
      "Used cosine_similarity from SKLearn to obtain similarity scores between movies.",
      "Take the movie name as input from the user and recommended a similar movie based on the similarity score. ",
    ],
    link: "https://colab.research.google.com/drive/1mu4QISPROeBvTFrXVh2ITR5bbpTWuRMk?usp=sharing",
  },
  {
    catetogry: "AI And ML",
    name: "Big Mart Sales Prediction",
    image: "/assest/images/projectsimages/bigmart.png",
    tech: "Python, Scikit Learn, Numpy, Pandas, Matplotlib,Seaborn",
    description: [
      "Develop a predictive model which predicts the sales of each product at a particular outlet.",
      "Performed data analysis to figure out the categorical types of features.",
      "Performed data preprocessing to handle null data",
      "Used labelEncoder from SKLearn to encode categorical data.",
      "Used the XGBoost Regressor method to develop the model.",
      "Evaluate model using R square score.",
    ],
    link: "https://colab.research.google.com/drive/1VORRoUacpc174Tgu6sb12xxPtIMZC8gk?usp=sharing",
  },
];

const Projects = () => {
  const [CurrentCategory, setCurrentCategory] = useState("All");

  const [ProjectsData, setProjectsData] = useState([]);

  useEffect(() => {
    if (CurrentCategory === "All") {
      setProjectsData(ProjectList);
    } else {
      const filteredData = ProjectList.filter((item) => {
        return item.catetogry === CurrentCategory;
      });
      setProjectsData(filteredData);
    }
  }, [CurrentCategory]);

  return (
    <Container>
      <img src="assest/images/sectionHeaders/projects.png" alt="projects" />
      <div className="mt-10">
        <Tabs
          CurrentCategory={CurrentCategory}
          setCurrentCategory={setCurrentCategory}
        />
      </div>
      <div className="mt-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-4">
          {ProjectsData.map((item, i) => {
            return (
              <ProjectCard
                name={item.name}
                image={item.image}
                tech={item.tech}
                desc={item.description}
                link={item.link}
              />
            );
          })}
        </div>
      </div>
    </Container>
  );
};

export default Projects;
